export interface JobFlyerCompositionOption {
  id: string;
  optionCode: string;
  label: string;
  description: string;
  bestFor: string;
}

export const DEFAULT_FLYER_LAYOUT_ID = 'role-spotlight';

export const FLYER_COMPOSITION_OPTIONS: JobFlyerCompositionOption[] = [
  {
    id: 'role-spotlight',
    optionCode: 'A',
    label: 'Role Spotlight',
    description:
      'Large role title, job-specific campaign visual, and concise facts',
    bestFor: 'Default LinkedIn and WhatsApp recruiting posts',
  },
  {
    id: 'editorial-blueprint',
    optionCode: 'B',
    label: 'Editorial Blueprint',
    description: 'Editorial composition with a diagram derived from the role',
    bestFor: 'Senior, platform, architecture, and leadership positions',
  },
  {
    id: 'tech-pulse',
    optionCode: 'C',
    label: 'Tech Pulse',
    description: 'High-impact central visual built from job responsibilities',
    bestFor: 'AI, cloud, data, and startup campaigns',
  },
  {
    id: 'kinetic-systems',
    optionCode: 'D',
    label: 'Kinetic Systems',
    description: 'Typography-led composition with routing paths and movement',
    bestFor: 'Engineering communities and attention-led posts',
  },
  {
    id: 'layered-platform',
    optionCode: 'E',
    label: 'Layered Platform',
    description: 'Approachable layered architecture with tactile depth',
    bestFor: 'Corporate, cloud, product, and light-theme campaigns',
  },
  {
    id: 'retro-technical',
    optionCode: 'F',
    label: 'Retro Technical',
    description: 'Memorable print-poster treatment with technical symbols',
    bestFor: 'Distinctive campaigns and hard-to-fill roles',
  },
];

const compositionById = (id?: string) =>
  FLYER_COMPOSITION_OPTIONS.find((option) => option.id === id);

export const resolveFlyerLayoutId = (id?: string): string =>
  compositionById(id?.trim().toLowerCase())?.id ?? DEFAULT_FLYER_LAYOUT_ID;

export const flyerLayoutLabel = (id?: string): string => {
  const option =
    compositionById(resolveFlyerLayoutId(id)) ?? FLYER_COMPOSITION_OPTIONS[0];
  return `${option.optionCode} · ${option.label}`;
};

export const mergeFlyerLayouts = (
  remote: Partial<JobFlyerCompositionOption>[]
): JobFlyerCompositionOption[] => {
  const remoteById = new Map(
    (remote ?? [])
      .filter((option) => option.id)
      .map((option) => [option.id!, option])
  );
  return FLYER_COMPOSITION_OPTIONS.map((fallback) => ({
    ...fallback,
    ...remoteById.get(fallback.id),
    id: fallback.id,
  }));
};
